import { GLOBAL_TALENT_ADVISOR_ENABLED } from '~/constants/hiringKitTypes'

// Closes /jobs/kit/offshore-advisor while the Accelerance partnership is on
// hold, so an old bookmark or shared link can't reach the referral CTA. The
// page and its components stay in the repo; flipping the flag reopens them.
//
// IMPORTANT: route middleware must RETURN navigateTo() — without the return it
// is a silent no-op.
export default defineNuxtRouteMiddleware(() => {
  if (!GLOBAL_TALENT_ADVISOR_ENABLED) return navigateTo('/jobs/kit')
})
